import { Accordion } from 'util/ui'
import Managed from './Managed'
import Section from './Section'

Accordion.Managed = Managed
Accordion.Section = Section

export default Accordion
